<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block">
                    <div class="row gy-gs">
                        <div class="col-lg-4 col-xl-4">
                            <div class="nk-block">
                                <div class="nk-block">
                                    <div class="card card-bordered text-light is-dark h-100">
                                        <div class="card-inner">
                                            <div class="nk-wg7">
                                                <div class="nk-wg7-stats">
                                                    <div class="nk-wg7-title">Total Investment</div>
                                                    <div class="number-lg amount"> ${{totalInvestment}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-xl-4">
                            <div class="nk-block">
                                <div class="nk-block">
                                    <div class="card card-bordered text-light is-dark h-100">
                                        <div class="card-inner">
                                            <div class="nk-wg7">
                                                <div class="nk-wg7-stats">
                                                    <div class="nk-wg7-title">Total Package</div>
                                                    <div class="number-lg amount">{{totalPackage}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-xl-4">
                            <div class="nk-block">
                                <div class="nk-block">
                                    <div class="card card-bordered text-light is-dark h-100">
                                        <div class="card-inner">
                                            <div class="nk-wg7">
                                                <div class="nk-wg7-stats">
                                                    <div class="nk-wg7-title">Expired Package</div>
                                                    <div class="number-lg amount">{{expiredPackage}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-xl-4">
                            <div class="nk-block">
                                <div class="nk-block">
                                    <div class="card card-bordered text-light is-dark h-100">
                                        <div class="card-inner">
                                            <div class="nk-wg7">
                                                <div class="nk-wg7-stats">
                                                    <div class="nk-wg7-title">Active Package</div>
                                                    <div class="number-lg amount">{{activePackage}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-xl-4">
                            <div class="nk-block">
                                <div class="nk-block">
                                    <div class="card card-bordered text-light is-dark h-100">
                                        <div class="card-inner">
                                            <div class="nk-wg7">
                                                <div class="nk-wg7-stats">
                                                    <div class="nk-wg7-title">Total Customer</div>
                                                    <div class="number-lg amount">{{totalCustomer}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-xl-4">
                            <div class="nk-block">
                                <div class="nk-block">
                                    <div class="card card-bordered text-light is-dark h-100">
                                        <div class="card-inner">
                                            <div class="nk-wg7">
                                                <div class="nk-wg7-stats">
                                                    <div class="nk-wg7-title">Total Withdrawal</div>
                                                    <div class="number-lg amount">${{totalWithdrawal}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-xl-4">
                            <div class="nk-block">
                                <div class="nk-block">
                                    <div class="card card-bordered text-light is-dark h-100">
                                        <div class="card-inner">
                                            <div class="nk-wg7">
                                                <div class="nk-wg7-stats">
                                                    <div class="nk-wg7-title">USDT Withdrawal</div>
                                                    <div class="number-lg amount">${{totalUsdtWithdrawal}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-xl-4">
                            <div class="nk-block">
                                <div class="nk-block">
                                    <div class="card card-bordered text-light is-dark h-100">
                                        <div class="card-inner">
                                            <div class="nk-wg7">
                                                <div class="nk-wg7-stats">
                                                    <div class="nk-wg7-title">USDT Deposit</div>
                                                    <div class="number-lg amount">${{totalUsdtInvestment}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>

                <div class="nk-block nk-block-lg">
                    <div class="row gy-gs">
                        <div class="col-md-12">
                            <div class="card-head">
                                <div class="card-title  mb-0">
                                    <h5 class="title">Investment</h5>
                                </div>
                                <div class="card-tools">
                                    <ul class="card-tools-nav">
                                        <li v-bind:class="graphFilter=='Last Year'? 'active' : ''"><a v-on:click="GetGraphSummary('Last Year')" href="javascript:void(0)">Last Year</a></li>
                                        <li v-bind:class="graphFilter=='Last Week'? 'active' : ''"><a v-on:click="GetGraphSummary('Last Week')" href="javascript:void(0)">Last Week</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tranx-list card card-bordered">
                                <div id="chart" :key="render">
                                    <apexchart type="area" height="350" :options="chartOptions" :series="series"></apexchart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="nk-block">
                    <div class="card card-bordered">
                        <div class="card-inner card-inner-lg">
                            <div class="align-center flex-wrap flex-md-nowrap g-4">
                                <div class="nk-block-image w-120px flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 118">
                                        <path d="M8.916,94.745C-.318,79.153-2.164,58.569,2.382,40.578,7.155,21.69,19.045,9.451,35.162,4.32,46.609.676,58.716.331,70.456,1.845,84.683,3.68,99.57,8.694,108.892,21.408c10.03,13.679,12.071,34.71,10.747,52.054-1.173,15.359-7.441,27.489-19.231,34.494-10.689,6.351-22.92,8.733-34.715,10.331-16.181,2.192-34.195-.336-47.6-12.281A47.243,47.243,0,0,1,8.916,94.745Z" transform="translate(0 -1)" fill="#f6faff" />
                                        <rect x="18" y="32" width="84" height="50" rx="4" ry="4" fill="#fff" />
                                        <rect x="26" y="44" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <rect x="50" y="44" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <rect x="74" y="44" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <rect x="38" y="60" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <rect x="62" y="60" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <path d="M98,32H22a5.006,5.006,0,0,0-5,5V79a5.006,5.006,0,0,0,5,5H52v8H45a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H73a2,2,0,0,0,2-2V94a2,2,0,0,0-2-2H66V84H98a5.006,5.006,0,0,0,5-5V37A5.006,5.006,0,0,0,98,32ZM73,94v4H45V94Zm-9-2H54V84H64Zm37-13a3,3,0,0,1-3,3H22a3,3,0,0,1-3-3V37a3,3,0,0,1,3-3H98a3,3,0,0,1,3,3Z" transform="translate(0 -1)" fill="#798bff" />
                                        <path d="M61.444,41H40.111L33,48.143V19.7A3.632,3.632,0,0,1,36.556,16H61.444A3.632,3.632,0,0,1,65,19.7V37.3A3.632,3.632,0,0,1,61.444,41Z" transform="translate(0 -1)" fill="#6576ff" />
                                        <path d="M61.444,41H40.111L33,48.143V19.7A3.632,3.632,0,0,1,36.556,16H61.444A3.632,3.632,0,0,1,65,19.7V37.3A3.632,3.632,0,0,1,61.444,41Z" transform="translate(0 -1)" fill="none" stroke="#6576ff" stroke-miterlimit="10" stroke-width="2" />
                                        <line x1="40" y1="22" x2="57" y2="22" fill="none" stroke="#fffffe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        <line x1="40" y1="27" x2="57" y2="27" fill="none" stroke="#fffffe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        <line x1="40" y1="32" x2="50" y2="32" fill="none" stroke="#fffffe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        <line x1="30.5" y1="87.5" x2="30.5" y2="91.5" fill="none" stroke="#9cabff" stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="28.5" y1="89.5" x2="32.5" y2="89.5" fill="none" stroke="#9cabff" stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="79.5" y1="22.5" x2="79.5" y2="26.5" fill="none" stroke="#9cabff" stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="77.5" y1="24.5" x2="81.5" y2="24.5" fill="none" stroke="#9cabff" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="90.5" cy="97.5" r="3" fill="none" stroke="#9cabff" stroke-miterlimit="10" />
                                        <circle cx="24" cy="23" r="2.5" fill="none" stroke="#9cabff" stroke-miterlimit="10" />
                                    </svg>
                                </div>
                                <div class="nk-block-content">
                                    <div class="nk-block-content-head px-lg-4">
                                        <h5>We�re here to help you!</h5>
                                        <p class="text-soft">Ask a question or file a support ticket, manage request, report an issues. Our team support team will get back to you by email.</p>
                                    </div>
                                </div>
                                <div class="nk-block-content flex-shrink-0">
                                    <a href="javascript:void(0)" v-on:click="GetSupport()" class="btn btn-lg btn-outline-primary">Get Support Now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import VueApexCharts from 'vue-apexcharts'
    export default {
        components: {
            apexchart: VueApexCharts,
        },
        name: 'Dashboard',
        data: function () {
            return {
                render: 0,
                totalInvestment: 0,
                totalPackage: 0,
                totalCustomer: 0,
                totalWithdrawal: 0,
                totalUsdtWithdrawal: 0,
                totalUsdtInvestment: 0,
                expiredPackage: 0,
                activePackage: 0,

                lastLogin: '',
                prop: '',
                graphFilter: 'Last Week',

                show: false,
                loading: false,
                checkExpiredPackage: false,

                series: [{
                    name: 'Bonus Earning',
                    data: []
                }],
                chartOptions: {
                    colors: ['#f2bd12', '#f2bd12', '#f2bd12'],
                    chart: {
                        height: 350,
                        type: 'area'
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    xaxis: {
                        type: '',
                        categories: []
                    },
                },
            }
        },
        methods: {
            GetSupport: function () {
                this.$router.push('/Tickets');
            },
            

            GetGraphSummary: function (graphFilter) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.graphFilter = graphFilter;
                root.$https.get('/Report/GetAdminGraphSummary?graphFilter=' + graphFilter, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.series[0].data = [];
                        root.chartOptions.xaxis.categories = [];

                        response.data.forEach(function (item) {
                            root.series[0].data.push(item.debit);
                            root.chartOptions.xaxis.categories.push(item.day);

                        });
                        root.render++;
                    }
                }).catch(error => {
                    console.log(error)
                });
            },


            GetReportSammary: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Report/AdminDashboardReport', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        localStorage.setItem('PackagePlanAmount', response.data.depositAmount);

                        root.totalInvestment = response.data.totalInvestment;
                        root.totalPackage = response.data.totalPackage;
                        root.totalCustomer = response.data.totalCustomer;
                        root.totalWithdrawal = response.data.totalWithdrawal;
                        root.totalUsdtWithdrawal = response.data.sumTotalUsdtWithdrawal;
                        root.totalUsdtInvestment = response.data.totalUsdtInvestment;
                        root.expiredPackage = response.data.expiredPackage;
                        root.activePackage = response.data.activePackage;


                        root.series[0].data = [];
                        root.chartOptions.xaxis.categories = [];

                        response.data.graphTransactions.forEach(function (item) {
                            root.series[0].data.push(item.debit);
                            root.chartOptions.xaxis.categories.push(item.day);
                        });
                        root.render++;
                    }
                }).catch(error => {
                    console.log(error)
                });
            },

        },
        created: function () {

        },
        mounted: function () {
            this.GetReportSammary();
        },
    }
</script>